<template>
    <div class="container-fluid bg-eligibility m-0 p-0 animated fadeIn slow" style="height: 100vh;">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div v-if="userRole" class="mb-5 pb-5">
            <div v-if="userRole === 'admin' || userRole === 'driver' || userRole === 'industry'" class="container px-0"
                 style="position: relative;">
                <TheHeader/>
                <div class="d-flex flex-column content-wrapper mt-0 mt-md-5 pt-5">
                    <div class="align-self-center my-auto">

                        <div class="font-italic font-weight-bold text-uppercase title">
                            if you want to be the best
                        </div>
                        <div class="lime-bar-diag">
                            <img src="../assets/img/Asset_3.png" alt="" class="">
                        </div>
                        <div class="sub-title text-uppercase font-xs">you have to beat the best.</div>

                        <div class="d-flex justify-content-center">
                            <div class="font-italic pt-4 text-left ">
                                <div class="font-italic text-left mb-4">
                                    <div class="font-xl">
                                        <strong>Eligibility: </strong></div>
                                </div>
                                <p>Drivers who meet the following criteria from the previous season’s Formula 1,
                                    IndyCar, and
                                    NASCAR championships are eligible to score RUFUS points:</p>

                                <ul>
                                    <li>Concluded the previous season in the Top 5 in driver’s championship
                                        points.
                                    </li>
                                    <li>Concluded the previous season with multiple race wins + Top 10 in
                                        driver’s
                                        championship points.
                                    </li>
                                    <li>Active former champions in his/her category.</li>
                                </ul>

                                <aside class="text-right mt-4 pt-3"><strong>“If you want to be the best, you have to
                                    beat the best. ”</strong><br> - Parnelli
                                    Jones
                                </aside>
                                <p class="mt-4 pt-3">If you are an eligible driver based on the above, congratulations.
                                    This criteria will
                                    always stand.
                                    If you’re not, we might have a little secret. Contact us directly.</p>
                                <hr class="my-5">
                                <p>For any further information about how RUFUS works or why it works the way it works,
                                    please
                                    email <a href="mailto:ARCHITECT@ruf.us">ARCHITECT@ruf.us</a>. Don’t expect to get
                                    any other info besides RUFUS rules, though. He’s
                                    pretty weird about it.</p>

                                <p>For other inquiries, please email <a
                                        href="mailto:INQUIRIES@ruf.us">INQUIRIES@ruf.us</a>. We do not promise a
                                    response.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="font-xl font-weight-semi-bold">
                <div class="container mb-5 pb-5">
                    <TheHeader/>
                </div>
                <div style="margin-top: 200px;">
                    Sorry, you don't have the correct permissions to access this
                    page...
                </div>
            </div>
        </div>

        <div v-else class="font-xl font-weight-semi-bold container" style="margin-top: 200px;">Sorry, you don't have the
            correct permissions to access this page...
        </div>
    </div>
</template>

<script>
    import TheHeader from '../components/TheHeader';

    export default {
        name      : "eligibility",
        components: {
            TheHeader
        },
        computed  : {
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        watch     : {
            userRole (val) {
                if ( val === 'admin' || val === 'driver' || val === 'industry' ) {
                    // console.log('admin or driver...');
                    this.$router.push({name: 'eligibility'})
                } else {
                    // console.log('not admin or driver');
                    this.$router.push({name: 'login'})
                }
            },
            created () {
                this.$store.dispatch('getUserAccount')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .bg-eligibility {
        background-image: url(../assets/img/eligibility.png);
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
        background-attachment: fixed;
        overflow-x: auto;
    }

    a {
        color: $blue;
    }

    .content-wrapper {
        margin-top: 6rem;
    }

    li {
        font-weight: 600;
        padding-bottom: 16px;
        &:last-of-type {
            padding-bottom: 0;
        }
    }

    @media all and (max-width: 576px) {
        .content-wrapper {
            margin-top: 3rem;
            padding-bottom: 4rem;
            padding-left: 15px;
            padding-right: 15px;
        }

        .title {
            white-space: nowrap;
            overflow: hidden;
            margin-left: -80px;
        }

        .sub-title {
            margin-left: 180px;
            margin-top: 4px;
        }

        .points {
            font-size: 16px;
        }

        p {
            margin-bottom: 10px;
            font-size: 14px;
        }

        aside {
            font-size: 12px;
            width: 100% !important;
        }

        h4 {
            font-size: 1.2rem;
        }
    }

    @media all and (min-width: 577px) and (max-width: 767px) {

        .content-wrapper {
            margin-top: 4rem;
            padding-bottom: 4rem;
        }

        .title {
            margin-left: -30px;
        }

        .sub-title {
            margin-left: 250px;
        }
    }

    @media all and (min-width: 768px) and (max-width: 991px) {

        .content-wrapper {
            height: 90% !important;
            margin-top: 4rem;
            padding-bottom: 4rem;

        }

        .sub-title {
            margin-left: 220px;
        }
    }

    @media all and (min-width: 992px) and (max-width: 1199px) {

        .content-wrapper {
            height: 90% !important;
        }

        .title {
            margin-left: -52px;
        }

        .sub-title {
            margin-right: -240px;
            margin-bottom: 5rem;
        }
    }

    @media all and (min-width: 1200px) {

        .content-wrapper {
            height: 90% !important;
        }

        .title {
            margin-left: -52px;
        }

        .menu-item {
            font-size: 16px;
            margin-left: 2rem;
        }

        .sub-title {
            margin-right: -250px;
        }
    }

</style>
